/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProceedingParticipantActiveClaimReferencesCountResponse
 */
export interface ProceedingParticipantActiveClaimReferencesCountResponse {
    /**
     * 
     * @type {string}
     * @memberof ProceedingParticipantActiveClaimReferencesCountResponse
     */
    proceedingParticipantId: string;
    /**
     * 
     * @type {number}
     * @memberof ProceedingParticipantActiveClaimReferencesCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the ProceedingParticipantActiveClaimReferencesCountResponse interface.
 */
export function instanceOfProceedingParticipantActiveClaimReferencesCountResponse(value: object): value is ProceedingParticipantActiveClaimReferencesCountResponse {
    if (!('proceedingParticipantId' in value) || value['proceedingParticipantId'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ProceedingParticipantActiveClaimReferencesCountResponseFromJSON(json: any): ProceedingParticipantActiveClaimReferencesCountResponse {
    return ProceedingParticipantActiveClaimReferencesCountResponseFromJSONTyped(json, false);
}

export function ProceedingParticipantActiveClaimReferencesCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProceedingParticipantActiveClaimReferencesCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'proceedingParticipantId': json['proceedingParticipantId'],
        'count': json['count'],
    };
}

export function ProceedingParticipantActiveClaimReferencesCountResponseToJSON(json: any): ProceedingParticipantActiveClaimReferencesCountResponse {
    return ProceedingParticipantActiveClaimReferencesCountResponseToJSONTyped(json, false);
}

export function ProceedingParticipantActiveClaimReferencesCountResponseToJSONTyped(value?: ProceedingParticipantActiveClaimReferencesCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proceedingParticipantId': value['proceedingParticipantId'],
        'count': value['count'],
    };
}

